import { render, staticRenderFns } from "./TotalView.vue?vue&type=template&id=3eb4b4d6"
import script from "./TotalView.vue?vue&type=script&lang=js"
export * from "./TotalView.vue?vue&type=script&lang=js"
import style0 from "./TotalView.vue?vue&type=style&index=0&id=3eb4b4d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports